import React, { useState } from 'react';
import {
  Typography,
  TextField,
  Grid,
  useTheme,
  Button,
  Container,
  Hidden,
  useMediaQuery,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Checkbox,
  FormControl,
  FormGroup,
  FormHelperText,
  Box,
  Stack,
} from '@mui/material';
import { Field, Formik } from 'formik';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import Loading from 'react-fullscreen-loading';
import ReactCodeInput from 'react-code-input';
import signupSchool from '../../../assets/signupSchool.png';
import signupAlyosef from '../../../assets/alyousef/login.png';

import {
  firestore,
  auth,
  recaptchaVerifier,
  _customApp,
} from '@tabletuck/firebase-services';
import signup from '../../../assets/signup.gif';
import tabletuck from '../../../assets/tabletuck.gif';
import fattyBattyLogin from '../../../assets/burgerLogin.jpg';
import fattyBattyVerify from '../../../assets/burgerVerify.jpg';
import fattyBattyLogo from '../../../assets/fattyBattyLogo.png';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { loggedInSuccess } from '@tabletuck/redux-slices';
import { environment } from 'apps/table-tuck-web/src/environments/environment';
import CustomPhoneNumber from '../../components/PhoneNumber/PhoneInput';
import './styles.css';
import { useTranslation } from 'react-i18next';
import { setCart, setUser } from '../../../../../../libs/redux-slices/src';
import PhoneInternational from '../../components/PhoneNumber/phoneinternational';
import { useAnonymousAuth } from '../../hooks/useAnonymousAuth';
import firebase from 'firebase';

const SignUp = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const xsDown = useMediaQuery(theme.breakpoints.down('xs'));
  const navigate = useNavigate();
  const location = useLocation();

  // Anonymous auth support for migrating cart and data
  const { migrateToAuthenticatedUser, isAnonymous, syncCartFromFirebase } =
    useAnonymousAuth();
  // Force-redirect back to order success if signup was reached from confirm order
  React.useEffect(() => {
    try {
      const redirectAfterAuth = sessionStorage.getItem('redirectAfterAuth');

      const cameFromConfirmOrder =
        redirectAfterAuth === '/confirmorder' ||
        location?.state?.returnTo === '/confirmorder' ||
        location?.state?.from === '/confirmorder';

      const alreadyHandled =
        sessionStorage.getItem('confirmRedirectHandled') === 'true';

      if (cameFromConfirmOrder && !alreadyHandled) {
        sessionStorage.setItem('confirmRedirectHandled', 'true');
        navigate('/order-success', { replace: true });
      }
    } catch (e) {}
  }, [navigate, location]);
  const [id, setId] = useState(null);
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [expandForm, setExpandForm] = useState(false);
  const [OTP, setOTP] = useState('');
  const [verifiedNum, setVerifiedNum] = useState(false);
  const [user, setUserstate] = useState();
  console.log('user', user);
  
  const [open, setOpen] = useState(false);
  const [err, setErr] = useState('');
  const [t] = useTranslation();
  const [isPhoneVerification, setIsPhoneVerification] = useState(false);
  const [isSendingOTP, setIsSendingOTP] = useState(false);
  const storedItems = JSON.parse(localStorage.getItem('cartItems'));

  // Helper function to check if email already exists
  // Uses Firebase Auth's fetchSignInMethodsForEmail for better performance
  // Falls back to Firestore check if needed
 
  const openDialog = async (user) => {
    const hasFirstName = !!user.firstName && user.firstName.trim().length > 0;
    const hasLastName = !!user.lastName && user.lastName.trim().length > 0;
    const hasFullName = !!user.fullName && user.fullName.trim().length > 0;
    const hasEmail = !!user.email && user.email.trim().length > 0;

    // If any of the key profile fields are missing, force the dialog to complete profile
    if (!hasEmail || (!hasFirstName || !hasLastName) || !hasFullName) {
      setAuthenticated(false);
      setOpen(true);
      return;
    }

    // All required fields are present -> continue login flow
    if (hasFullName && hasEmail && hasFirstName && hasLastName) {
      setAuthenticated(true);
      setOpen(false);

      // Handle anonymous user migration for existing users
      if (isAnonymous) {
        const migrationResult = await migrateToAuthenticatedUser(
          user.uid,
          false
        );
        if (migrationResult.success) {
          // Sync cart to Firebase after migration
          await syncCartFromFirebase();
        }
      }

      dispatch(loggedInSuccess({ token: user.uid, isAnonymous: false }));

      // Always redirect to home page after login
      sessionStorage.removeItem('redirectAfterAuth');
      navigate('/');
    }
  };

  const handleSubmit = async (values, formikHelpers) => {
    setLoading(true);
    try {
      if (!authenticated) {
        const firstName = values.firstName?.trim() || '';
        const lastName = values.lastName?.trim() || '';

        // Capitalize first letter of each name
        const formattedFirstName =
          firstName.charAt(0).toUpperCase() + firstName.slice(1);
        const formattedLastName =
          lastName.charAt(0).toUpperCase() + lastName.slice(1);
        const fullName = `${formattedFirstName} ${formattedLastName}`.trim();

        const formData = {
          email: values.email ? values.email.toLowerCase().trim() : '',
          firstName: formattedFirstName,
          lastName: formattedLastName,
          fullName: fullName,
          sendSms: values.sendSms,
          defaultLanguage: 'en',
        };
        await firestore
          .collection('users')
          .doc(id)
          .set(formData, { merge: true })
          .catch((e) => {
            // Error handled silently
          });

        // Immediately update Redux userData so profile/personal info see latest values
        try {
          const updatedUserData = {
            ...(user || {}),
            ...formData,
            uid: user?.uid || id,
          };
          dispatch(setUser({ userData: updatedUserData }));
        } catch (updateStateError) {
          console.warn(
            '⚠️ [SIGNUP] Failed to update Redux userData after dialog submit:',
            updateStateError
          );
        }

        // Link email to Auth user using email+password credential (phone is primary auth).
        // IMPORTANT:
        // - If the Firebase Auth user already has an email, treat this dialog as profile info only.
        // - If the Auth user has NO email yet (phone-only account), link an email+password
        //   credential ONCE using a random password so Firebase enforces email uniqueness.
        if (values.email && auth.currentUser) {
          const normalizedEmail = values.email.toLowerCase().trim();
          const authUser = auth.currentUser;
          const existingEmail = (user?.email || authUser.email || '')
            .toLowerCase()
            .trim();
          const authHasEmail = !!authUser.email;
          const hasEmailChanged =
            !existingEmail || normalizedEmail !== existingEmail;

          const shouldLinkAuthEmail =
            !authHasEmail && !!normalizedEmail && hasEmailChanged;

          if (shouldLinkAuthEmail) {
            try {
              const randomPassword =
                Math.random().toString(36).slice(-10) +
                Date.now().toString(36);

              const credential = firebase.auth.EmailAuthProvider.credential(
                normalizedEmail,
                randomPassword
              );

              await authUser.linkWithCredential(credential);
            } catch (error) {
              console.error('❌ [SIGNUP] Error linking email credential:', {
                code: error.code,
                message: error.message,
                email: values.email,
              });

              const message =
                (error && error.message) ||
                'Error updating email. Please check your email and try again.';

              // Show error inside the modal (email field) instead of under the phone input
              if (formikHelpers && typeof formikHelpers.setFieldError === 'function') {
                formikHelpers.setFieldError('email', message);
              } else {
                setErr(message);
              }

              setLoading(false);
              return;
            }
          }
        }

        setLoading(false);
        setAuthenticated(true);
        setOpen(false);
        setErr('');

        // Handle anonymous user migration if needed
        console.log(
          '🔐 [SIGNUP] handleSubmit - checking for anonymous migration (new user)',
          {
            isAnonymous,
            userId: user?.uid,
          }
        );

        if (isAnonymous) {
          const migrationResult = await migrateToAuthenticatedUser(
            user.uid,
            true
          );
          if (migrationResult.success) {
            // Sync cart to Firebase after migration
            await syncCartFromFirebase();
          }
        }

        dispatch(loggedInSuccess({ token: user.uid, isAnonymous: false }));

        // Always redirect to home page after login
        sessionStorage.removeItem('redirectAfterAuth');
        navigate('/');
      } else {
        setLoading(false);
        setOpen(false);
        setErr('');
      }
    } catch (e) {
      const message = e?.message || t('tryAgain');
      if (formikHelpers && typeof formikHelpers.setStatus === 'function') {
        formikHelpers.setStatus({ submitError: message });
      } else {
        setErr(message);
      }
      setLoading(false);
    }
  };
  let phoneNumbert = phoneNumber;

  const handleSubmitt = async (values) => {
    setLoading(true);
    try {
      if (!user) {
        const authUser = await auth.currentUser;
        const doc = await firestore.collection('users').doc(authUser?.uid);

        // Check if user document already exists
        const existingDoc = await doc.get();
        const isCreatingNewUser = !existingDoc.exists;

        if (isCreatingNewUser) {
          // Create new user document
          await firestore.collection('users').doc(doc.id).set({
            fullName: '',
            email: '', // Will be filled in dialog
            defaultLanguage: 'en',
            phoneNumber: phoneNumbert,
            uid: authUser.uid,
            bagItems: [],
            defaultPaymentAddress: '',
            defaultDeliveryAddress: '',
            defaultStore: '',
            pickupOrDelivery: '',
            createdAt: new Date(),
          });
        }

        // Call getUser with flag indicating if user was just created
        await getUser(doc.id, isCreatingNewUser);
        setErr('');
      } else {
        openDialog(user);
      }
    } catch (e) {
      setErr(e.message);
      setLoading(false);
    }
  };

  const getUser = async (userId, wasJustCreated = false) => {
    setLoading('register');
    try {
      if (!userId) {
        throw new Error('User ID is required');
      }

      const userDocRef = firestore.collection('users').doc(userId);
      const userDoc = await userDocRef.get();

      if (userDoc.exists) {
        const userData = userDoc.data();
        const isNewUser = wasJustCreated; // Use the flag to determine if this is a new user

        // Handle anonymous user migration if needed
        if (isAnonymous) {
          const migrationResult = await migrateToAuthenticatedUser(
            userId,
            isNewUser
          );
          if (!migrationResult.success) {
            // Migration failed - error is already logged in the hook
          }
        }

        // Get the most up-to-date user data after migration
        const finalUserDoc = await userDocRef.get();
        const finalUserData = finalUserDoc.data();

        setUserstate(finalUserData);
        setId(finalUserDoc.id);
        window.localStorage.setItem('docid', finalUserDoc.id);

        await LocalstorageAdd(finalUserData, isNewUser); // Pass isNewUser flag
        openDialog(finalUserData);
      } else {
        await userDocRef.set({
          fullName: '',
          email: '', // Will be filled in dialog
          phoneNumber: phoneNumbert,
          uid: userId,
          bagItems: [],
          defaultPaymentAddress: '',
          defaultDeliveryAddress: '',
          defaultStore: '',
          pickupOrDelivery: '',
          createdAt: new Date(),
        });

        // Handle anonymous user migration for new user
        if (isAnonymous) {
          const migrationResult = await migrateToAuthenticatedUser(
            userId,
            true
          );
          if (!migrationResult.success) {
            // Migration failed - error is already logged in the hook
          }
        }

        // For new users, get the user data after migration and handle localStorage
        const finalUserDoc = await userDocRef.get();
        const finalUserData = finalUserDoc.data();

        setUserstate(finalUserData);
        setId(finalUserDoc.id);
        window.localStorage.setItem('docid', finalUserDoc.id);

        await LocalstorageAdd(finalUserData, true); // Pass isNewUser = true for new users

        handleSubmitt();
      }
    } catch (e) {
      // Do NOT overwrite existing user data with empty fields on error.
      // Just surface the error so we can see what's going wrong.
      console.error('❌ [SIGNUP] getUser failed:', e);
      setErr(e.message || 'Failed to load your profile data. Please try again.');
      setLoading(false);
    }
  };

  const handlePinChange = (pinCode) => {
    setOTP(pinCode);

    if (pinCode.length === 6) {
      let confirmationResult = window.confirmationResult;

      confirmationResult
        .confirm(pinCode)
        .then(async (userCredential) => {
          const uid = userCredential.user.uid;

          await getUser(uid); // Will determine isNewUser inside getUser

          setErr('');
          setVerifiedNum(true);
          setIsPhoneVerification(false);
        })
        .catch((e) => {
          let notCorrect =
            'The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.';
          e.message === notCorrect
            ? setErr(t('incorrectCodeResendCode'))
            : setErr(e.message);
        });
    }

    setOTP('');
  };
  const requestOTP = async (e) => {
    setErr('');
    dispatch(setCart([]));
    if (phoneNumbert.length < 12) {
      setErr(`${t('validNumber')}`);
      e.preventDefault();
    } else {
      setErr('');
      e.preventDefault();
      setIsSendingOTP(true);
      geterate();
      let appvarifier = window.recaptchaVerifier;

      const RECAPTCHA_TIMEOUT_MS = 20000;
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(
          () => reject(new Error('RECAPTCHA_TIMEOUT')),
          RECAPTCHA_TIMEOUT_MS
        )
      );

      try {
        await Promise.race([
          auth.signInWithPhoneNumber(phoneNumbert, appvarifier),
          timeoutPromise,
        ])
          .then((confirmationResult) => {
            setIsSendingOTP(false);
            setIsPhoneVerification(true);
            setExpandForm(true);
            window.confirmationResult = confirmationResult;
            window.recaptchaVerifier = null;
            setErr('');
          })
          .catch((error) => {
            if (window.recaptchaVerifier) {
              try {
                window.recaptchaVerifier.reset();
              } catch (resetError) {
                console.error(
                  '❌ [SIGNUP] Failed to reset reCAPTCHA:',
                  resetError
                );
              }
            }
            setIsSendingOTP(false);
            setExpandForm(false);
            setIsPhoneVerification(false);
            const isTimeout = error?.message === 'RECAPTCHA_TIMEOUT';
            const message = isTimeout
              ? 'Could not connect to the reCAPTCHA service. Please check your internet connection and reload the page to try again.'
              : (error?.message || t('validNumber'));
            setErr(message);
          });
      } catch (unhandled) {
        setIsSendingOTP(false);
        setExpandForm(false);
        setIsPhoneVerification(false);
        setErr(unhandled?.message || t('validNumber'));
      }
    }
  };
  const geterate = () => {
    // Use the same simple, stable pattern as Checkout/ConfirmOrderPage
    if (!window.recaptchaVerifier) {
      try {
        window.recaptchaVerifier = new recaptchaVerifier(
          'recaptcha-container',
          {
            size: 'invisible',
          },
          _customApp
        );
      } catch (error) {
        console.error('❌ [SIGNUP] Failed to create reCAPTCHA verifier:', error);
      }
    }
  };

  const LocalstorageAdd = async (userdata, isNewUser = false) => {
    try {
      setUserstate(userdata);
      const firestoreItems = userdata.bagItems || [];

      let items = [];

      // Check if anonymous user has cart items in localStorage
      const hasAnonymousCart =
        storedItems && Array.isArray(storedItems) && storedItems.length > 0;

      if (hasAnonymousCart) {
        // SCENARIO: Anonymous user with cart items logging in
        // Always use anonymous cart items, discard existing account items
        console.log(
          '🛒 [SIGNUP] Anonymous cart found - replacing existing cart',
          {
            anonymousItems: storedItems.length,
            discardedItems: firestoreItems.length,
            isNewUser,
          }
        );

        items = [...storedItems];

        // Update Firestore with anonymous cart (replaces existing cart)
        await firestore.collection('users').doc(auth?.currentUser?.uid).set(
          {
            bagItems: items,
          },
          { merge: true }
        );

        // Clear localStorage after replacing cart
        localStorage.removeItem('cartItems');
        console.log('✅ [SIGNUP] Replaced existing cart with anonymous cart');
      } else {
        // SCENARIO: No anonymous cart - keep existing Firestore items
        console.log('ℹ️ [SIGNUP] No anonymous cart - keeping existing cart', {
          existingItems: firestoreItems.length,
          isNewUser,
        });

        items = [...firestoreItems];
      }

      DispatchAllitems(items, userdata);
    } catch (error) {
      console.error('❌ [SIGNUP] Error in LocalstorageAdd:', error);
    }
  };

  const DispatchAllitems = (items, user) => {
    const updatedUser = { ...user, bagItems: items };
    dispatch(setCart(items));
    dispatch(setUser({ userData: updatedUser }));
  };

  return (
    <Container
      maxWidth={'xl'}
      style={{
        padding: '0px',
      }}
      sx={{
        px: { xs: 2, sm: 3, md: 0 },
      }}
    >
      <Grid
        container
        minHeight={{
          xs: '50vh',
          sm: '90vh',
        }}
        sx={{
          py: { xs: 4, sm: 6, md: 8 },
        }}
      >
        <Grid
          item
          xs={12}
          lg={6}
          display={'flex'}
          justifyContent={'center'}
          flexDirection={'column'}
          alignItems={'center'}
          sx={{
            px: { xs: 2, sm: 4, md: 6 },
            pb: { xs: 4, sm: 0 },
          }}
        >
          <Stack
            width={{
              xs: '100%',
              sm:
                environment?.restaurantId === 'fattyPattyDev' ||
                environment?.restaurantId === 'fattyPatty'
                  ? '404px'
                  : '100%',
            }}
            maxWidth={{
              xs: '100%',
              sm:
                environment?.restaurantId === 'fattyPattyDev' ||
                environment?.restaurantId === 'fattyPatty'
                  ? '404px'
                  : '500px',
            }}
            alignContent={{
              xs: 'center',
              sm: 'start',
            }}
            alignItems={{
              xs: 'center',
              sm: 'start',
            }}
            gap={{ xs: 3, sm: 4 }}
          >
            {(environment?.restaurantId === 'fattyPattyDev' ||
              environment?.restaurantId === 'fattyPatty') && (
              <img
                src={fattyBattyLogo}
                alt="Fatty Patty Logo"
                style={{
                  width: '104px',
                  height: '104px',
                }}
              />
            )}
            <Stack gap={{ xs: 1, sm: 1 }} width="100%">
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 'bold',
                  display: 'flex',
                  justifyContent: {
                    xs: 'center',
                    sm: 'start',
                  },
                  fontSize: {
                    xs: '24px',
                    sm: '28px',
                    md: '32px',
                  },
                  textAlign: {
                    xs: 'center',
                    sm: 'left',
                  },
                  width: '100%',
                  ...(environment?.restaurantId === 'fattyPattyDev' ||
                  environment?.restaurantId === 'fattyPatty'
                    ? {
                        fontFamily: 'oswald, sans-serif',
                        color: '#1F2937',
                      }
                    : {}),
                }}
              >
                {(environment?.restaurantId === 'fattyPattyDev' ||
                  environment?.restaurantId === 'fattyPatty') &&
                !isPhoneVerification
                  ? 'Welcome Back 👋'
                  : (environment?.restaurantId === 'fattyPattyDev' ||
                      environment?.restaurantId === 'fattyPatty') &&
                    isPhoneVerification
                  ? 'Verification Code'
                  : t('signUp')}
              </Typography>

              <Typography
                variant="p"
                sx={{
                  color:
                    environment?.restaurantId === 'fattyPattyDev' ||
                    environment?.restaurantId === 'fattyPatty'
                      ? '#313957'
                      : 'gray',
                  display: 'flex',
                  justifyContent: {
                    xs: 'center',
                    sm:
                      environment?.restaurantId === 'fattyPattyDev' ||
                      environment?.restaurantId === 'fattyPatty'
                        ? 'flex-start'
                        : 'center',
                  },
                  textAlign: {
                    xs: 'center',
                    sm: 'left',
                  },
                  fontSize: {
                    xs: '14px',
                    sm: '16px',
                  },
                  lineHeight: '160%',
                  width: '100%',
                  ...(environment?.restaurantId === 'fattyPattyDev' ||
                  environment?.restaurantId === 'fattyPatty'
                    ? {
                        fontFamily: 'Poppins, sans-serif',
                      }
                    : {}),
                }}
              >
                {(environment?.restaurantId === 'fattyPattyDev' ||
                  environment?.restaurantId === 'fattyPatty') &&
                !isPhoneVerification
                  ? ' Please enter your details to sign up.'
                  : (environment?.restaurantId === 'fattyPattyDev' ||
                      environment?.restaurantId === 'fattyPatty') &&
                    isPhoneVerification
                  ? 'Please type the verification code sent to your phone.'
                  : t('signupDetails')}
              </Typography>
            </Stack>

            <SignUpDailog
              open={open}
              handleSubmit={handleSubmit}
              user={user}
            />
            <PhoneVerificationForm
              phoneNumber={phoneNumber}
              setPhoneNumber={setPhoneNumber}
              expandForm={expandForm}
              verifiedNum={verifiedNum}
              requestOTP={requestOTP}
              handlePinChange={handlePinChange}
              err={err}
              isSendingOTP={isSendingOTP}
            />
          </Stack>
        </Grid>
        <Grid
          item
          xs={12}
          lg={6}
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          sx={{
            pt: { xs: 4, sm: 6, lg: 0 },
            px: { xs: 2, sm: 4, lg: 0 },
          }}
        >
          <Hidden smDown>
            <img
              style={{
                ...(environment?.restaurantId === 'fattyPattyDev' ||
                environment?.restaurantId === 'fattyPatty'
                  ? {
                      width: '100%',
                      maxWidth: '572px',
                      height: 'auto',
                      aspectRatio: '572/563',
                      objectFit: 'cover',
                      borderRadius: '24px',
                    }
                  : {
                      width:
                        environment?.restaurantId === 'filfil' ? '100%' : '66%',
                      maxWidth: '572px',
                      height: 'auto',
                    }),
              }}
              src={
                environment?.restaurantId === 'elmbrookschools'
                  ? signupSchool
                  : environment?.restaurantId === 'alyousef'
                  ? signupAlyosef
                  : environment?.restaurantId === 'ttDemo'
                  ? tabletuck
                  : (environment?.restaurantId === 'fattyPattyDev' ||
                      environment?.restaurantId === 'fattyPatty') &&
                    !isPhoneVerification
                  ? fattyBattyLogin
                  : (environment?.restaurantId === 'fattyPattyDev' ||
                      environment?.restaurantId === 'fattyPatty') &&
                    isPhoneVerification
                  ? fattyBattyVerify
                  : signup
              }
              alt="signup pic"
            />
          </Hidden>
        </Grid>
      </Grid>
      <Loading
        loading={!!loading || isSendingOTP}
        background="rgba(86, 100, 210, 0.1)"
        loaderColor={environment.mainColor}
      />
    </Container>
  );
};
export default SignUp;

const SignUpDailog = ({ open, handleSubmit, user }) => {
  const { t } = useTranslation();

  // Prefer the most up-to-date user data:
  // 1) Redux authReducer.userData (kept in sync across app)
  // 2) Fallback to the user prop passed from Signup page
  const reduxUserData = useSelector((state) => state.authReducer.userData);
  const effectiveUser = reduxUserData || user || {};

  // Debug logs to understand why dialog fields might be empty
  if (open) {
    // eslint-disable-next-line no-console
    console.log('[SignUpDialog] Sources for initial values:', {
      reduxUserData,
      userProp: user,
      effectiveUser,
    });
  }

  // If the authenticated user already has an email, treat the dialog email
  // as read-only profile info (email changes should happen in profile, not here)
  const authHasEmailForDialog = !!(
    auth?.currentUser && auth.currentUser.email
  );

  // Helper function to check if email already exists
  const validateSchema = Yup.object().shape({
    email: Yup.string()
      .email(t('invalidEmail'))
      .required(t('profilee.required')),
    firstName: Yup.string()
      .matches(/^[a-zA-Z\s]+$/, 'First name can only contain letters')
      .min(2, 'First name must be at least 2 characters')
      .max(20, 'First name must be at most 20 characters')
      .required('First name is required'),
    lastName: Yup.string()
      .matches(/^[a-zA-Z\s]+$/, 'Last name can only contain letters')
      .min(2, 'Last name must be at least 2 characters')
      .max(20, 'Last name must be at most 20 characters')
      .required('Last name is required'),
    sendSms: Yup.boolean(),
  });
  return (
    <Formik
      enableReinitialize
      initialValues={{
        firstName: effectiveUser.firstName || '',
        lastName: effectiveUser.lastName || '',
        email: effectiveUser.email || '',
        sendSms:
          typeof effectiveUser.sendSms === 'boolean'
            ? effectiveUser.sendSms
            : false,
      }}
      validationSchema={validateSchema}
      onSubmit={(values, helpers) => handleSubmit(values, helpers)}
    >
      {({
        errors,
        touched,
        handleSubmit,
        values,
        handleChange,
        isSubmitting,
        isValid,
      }) => (
        <Dialog
          open={open}
          aria-labelledby="form-dialog-title"
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: '16px',
              boxShadow: '0 24px 48px rgba(0, 0, 0, 0.12)',
              padding: '8px',
            },
          }}
        >
          <DialogTitle
            id="form-dialog-title"
            sx={{
              textAlign: 'center',
              fontSize: '1.5rem',
              fontWeight: 600,
              color: '#1F2937',
              paddingTop: '24px',
              paddingBottom: '8px',
            }}
          >
            {t('updateYourData')}
          </DialogTitle>
          <DialogContent sx={{ padding: '16px 24px' }}>
            <DialogContentText
              sx={{
                marginBottom: '24px',
                textAlign: 'center',
                color: '#6B7280',
                fontSize: '0.95rem',
                lineHeight: 1.5,
              }}
            >
              {t('subscribeWebsite')}
            </DialogContentText>
            <Stack spacing={3}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Field
                    fullWidth
                    as={TextField}
                    variant="outlined"
                    name="firstName"
                    label="First Name"
                    helperText={touched.firstName && errors.firstName}
                    error={touched.firstName && errors.firstName && true}
                    onChange={handleChange('firstName')}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        backgroundColor: '#F9FAFB',
                        '& fieldset': {
                          borderColor: '#E5E7EB',
                        },
                        '&:hover fieldset': {
                          borderColor: environment.mainColor,
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: environment.mainColor,
                          borderWidth: '2px',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: '#6B7280',
                        '&.Mui-focused': {
                          color: environment.mainColor,
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    fullWidth
                    as={TextField}
                    variant="outlined"
                    name="lastName"
                    label="Last Name"
                    helperText={touched.lastName && errors.lastName}
                    error={touched.lastName && errors.lastName && true}
                    onChange={handleChange('lastName')}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        backgroundColor: '#F9FAFB',
                        '& fieldset': {
                          borderColor: '#E5E7EB',
                        },
                        '&:hover fieldset': {
                          borderColor: environment.mainColor,
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: environment.mainColor,
                          borderWidth: '2px',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: '#6B7280',
                        '&.Mui-focused': {
                          color: environment.mainColor,
                        },
                      },
                    }}
                  />
                </Grid>
              </Grid>
              <TextField
                fullWidth
                type="email"
                variant="outlined"
                name="email"
                label={t('careerss.email')}
                value={values.email}
                disabled={authHasEmailForDialog}
                error={touched.email && errors.email ? true : false}
                helperText={touched.email && errors.email}
                InputProps={{
                  endAdornment: (
                    <MailOutlineIcon
                      sx={{
                        color: environment.mainColor,
                        fontSize: '20px',
                      }}
                    />
                  ),
                }}
                onChange={handleChange('email')}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '12px',
                    backgroundColor: '#F9FAFB',
                    '& fieldset': {
                      borderColor: '#E5E7EB',
                    },
                    '&:hover fieldset': {
                      borderColor: environment.mainColor,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: environment.mainColor,
                      borderWidth: '2px',
                    },
                  },
                  '& .MuiInputLabel-root': {
                    color: '#6B7280',
                    '&.Mui-focused': {
                      color: environment.mainColor,
                    },
                  },
                }}
              />
              <FormControl
                error={touched.sendSms && Boolean(errors.sendSms)}
                component="fieldset"
                sx={{
                  // backgroundColor: '#F9FAFB',
                  padding: '16px',
                  borderRadius: '12px',
                  // border: `1px solid ${
                  //   touched.sendSms && errors.sendSms ? '#EF4444' : '#E5E7EB'
                  // }`,
                }}
              >
                <FormGroup>
                  <Typography
                    variant="body2"
                    sx={{ color: '#4B5563', fontFamily: 'Jost', mb: 1 }}
                  >
                    By creating an account or placing an order, you’ll
                    automatically be enrolled in our Fatty Patty Rewards Program
                  </Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={values.sendSms}
                        onChange={handleChange('sendSms')}
                        sx={{
                          color: 'rgb(253, 86, 34)',
                          '&.Mui-checked': { color: 'rgb(253, 86, 34)' },
                        }}
                      />
                    }
                    label="Yes, I want to receive news, promotions, and special offers by email or text"
                  />
                </FormGroup>
                {touched.sendSms && errors.sendSms && (
                  <FormHelperText sx={{ color: '#EF4444', marginTop: '4px' }}>
                    {errors.sendSms}
                  </FormHelperText>
                )}
              </FormControl>
            </Stack>
          </DialogContent>
          <DialogActions sx={{ padding: '16px 24px 32px' }}>
            <Button
              onClick={async () => {
                if (!isSubmitting) {
                  await handleSubmit();
                }
              }}
              type="submit"
              variant="contained"
              fullWidth
              disabled={
                isSubmitting ||
                !values.email ||
                !values.firstName ||
                !values.lastName ||
                !isValid
              }
              sx={{
                backgroundColor: environment.mainColor,
                color: 'white',
                borderRadius: '12px',
                padding: '12px 0',
                fontSize: '1rem',
                fontWeight: 600,
                textTransform: 'none',
                boxShadow: `0 4px 12px ${environment.mainColor}40`,
                '&:hover': {
                  backgroundColor: environment.mainColor,
                  transform: 'translateY(-2px)',
                  boxShadow: `0 8px 24px ${environment.mainColor}50`,
                },
                '&:active': {
                  transform: 'translateY(0)',
                },
                transition: 'all 0.2s ease-in-out',
                '&:disabled': {
                  backgroundColor: '#D1D5DB',
                  color: '#9CA3AF',
                },
              }}
            >
              {isSubmitting ? t('loading') : t('signUp')}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Formik>
  );
};

const PhoneVerificationForm = ({
  phoneNumber,
  setPhoneNumber,
  expandForm,
  verifiedNum,
  requestOTP,
  handlePinChange,
  err,
  isSendingOTP,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const xsDown = useMediaQuery(theme.breakpoints.down('xs'));
  const [acceptedAll, setAcceptedAll] = useState(false);
  const navigate = useNavigate();

  return (
    <Formik
      initialValues={{
        phoneNumber: '',
      }}
    >
      {() => (
        <>
          <Grid spacing={3} container>
            <Grid
              item
              justify="space-around"
              container
              xs={12}
              spacing={1}
              style={{
                flexDirection: xsDown ? 'row' : 'unset',
                marginTop: '10px',
              }}
            >
              <Grid
                item
                xs={12}
                lg={12}
                sx={{
                  display: 'flex',
                  justifyContent: {
                    xs: 'center',
                    sm: 'flex-start',
                  },
                  alignItems: {
                    xs: 'center',
                    sm: 'flex-start',
                  },
                }}
              >
                <form onSubmit={requestOTP}>
                  <PhoneInternational
                    phoneNumber={phoneNumber}
                    setPhoneNumber={setPhoneNumber}
                  />

                  <br />
                  {!expandForm && (
                    <FormGroup style={{ marginTop: 8, marginBottom: 4 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={acceptedAll}
                            onChange={(e) => setAcceptedAll(e.target.checked)}
                            color="primary"
                          />
                        }
                        label={
                          <span>
                            I accept the{' '}
                            <span
                              onClick={() => navigate('/terms-conditions')}
                              style={{
                                cursor: 'pointer',
                                textDecoration: 'underline',
                              }}
                            >
                              Terms &amp; Conditions
                            </span>{' '}
                            and{' '}
                            <span
                              onClick={() => navigate('/privacy-policy')}
                              style={{
                                cursor: 'pointer',
                                textDecoration: 'underline',
                              }}
                            >
                              Privacy Policy
                            </span>
                          </span>
                        }
                      />
                    </FormGroup>
                  )}
                  {!expandForm && (
                    <Box
                      style={{
                        display: 'flex',
                        justifyContent:
                          environment?.restaurantId === 'fattyPattyDev' ||
                          environment?.restaurantId === 'fattyPatty'
                            ? 'flex-start'
                            : 'center',
                      }}
                    >
                      <Button
                        size="large"
                        type="submit"
                        variant="contained"
                        disabled={!acceptedAll || isSendingOTP}
                        style={{
                          backgroundColor: environment.mainColor,
                          marginTop:
                            environment?.restaurantId === 'fattyPattyDev' ||
                            environment?.restaurantId === 'fattyPatty'
                              ? '0'
                              : '15px',
                          ...(environment?.restaurantId === 'fattyPattyDev' ||
                          environment?.restaurantId === 'fattyPatty'
                            ? {
                                fontSize: '16px',
                                lineHeight: '160%',
                                letterSpacing: '0%',
                                fontFamily: 'Roboto, sans-serif',
                                boxShadow: 'none',
                                borderRadius: '44px',
                                padding: '16px 0px',
                                height: '48px',
                                width: '100%',
                                textTransform: 'capitalize',
                                opacity: isSendingOTP ? 0.7 : 1,
                              }
                            : {
                                opacity: isSendingOTP ? 0.7 : 1,
                              }),
                        }}
                      >
                        {isSendingOTP
                          ? 'Sending...'
                          : environment?.restaurantId === 'fattyPattyDev' ||
                            environment?.restaurantId === 'fattyPatty'
                          ? 'Log In'
                          : t('verifyNumber')}
                      </Button>
                    </Box>
                  )}
                  <div style={{ height: '10px', width: '100px' }} />
                  {expandForm === true && verifiedNum === false && (
                    <>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          direction: 'initial',
                        }}
                      >
                        <ReactCodeInput
                          type="text"
                          onChange={handlePinChange}
                          fields={6}
                          inputMode="numeric"
                          pattern="[0-9]*"
                        />
                      </div>
                      <br />
                    </>
                  )}

                  <div id="recaptcha-container"></div>
                </form>
              </Grid>
            </Grid>
          </Grid>
          {err && (
            <Box
              style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '12px',
                backgroundColor:
                  environment?.restaurantId === 'fattyPattyDev' ||
                  environment?.restaurantId === 'fattyPatty'
                    ? '#FEF2F2'
                    : 'transparent',
                borderRadius:
                  environment?.restaurantId === 'fattyPattyDev' ||
                  environment?.restaurantId === 'fattyPatty'
                    ? '8px'
                    : '0',
                border:
                  environment?.restaurantId === 'fattyPattyDev' ||
                  environment?.restaurantId === 'fattyPatty'
                    ? '1px solid #FCA5A5'
                    : 'none',
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: '#D32F2F',
                  fontSize:
                    environment?.restaurantId === 'fattyPattyDev' ||
                    environment?.restaurantId === 'fattyPatty'
                      ? '14px'
                      : 15,
                  fontFamily:
                    environment?.restaurantId === 'fattyPattyDev' ||
                    environment?.restaurantId === 'fattyPatty'
                      ? 'Poppins, sans-serif'
                      : 'inherit',
                  textAlign: 'center',
                  fontWeight: 500,
                }}
              >
                {err}
              </Typography>
            </Box>
          )}
        </>
      )}
    </Formik>
  );
};
